import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PageContainerService } from '../../../../services/page-container.service';
import { ViewDetectionService } from '../../../../services/view-detection.service';
import moment from 'moment';
import { MultiSelectModule } from 'primeng/multiselect';
import { tap } from 'rxjs';

@Component({
  selector: 'z-top-header-filters',
  standalone: true,
  imports: [CommonModule, MultiSelectModule, FormsModule],
  templateUrl: './top-header-filters.component.html',
})
export class TopHeaderFiltersComponent {
  dateTime = signal<{ date: string; time: string }>({ date: '', time: '' });
  intervalId: NodeJS.Timeout | null = null;

  gridView$ = this.viewDetection.gridView.pipe(
    tap(view => {
      if (view === 'large' || view === 'xLarge') {
        this.dateTime.set(this.formatDateTime());
        this.intervalId = setInterval(() => {
          this.dateTime.set(this.formatDateTime());
        }, 60000);
      }
    }),
  );

  constructor(
    readonly pageContainerService: PageContainerService,
    readonly viewDetection: ViewDetectionService,
  ) {
    this.dateTime.set(this.formatDateTime());
  }

  ngOnInit() {
    this.dateTime.set(this.formatDateTime());
    this.intervalId = setInterval(() => {
      this.dateTime.set(this.formatDateTime());
    }, 60000);
  }

  formatDateTime(): { date: string; time: string } {
    const now = moment();
    const formattedDate = now.format('dddd, MMMM DD, YYYY'); // Sunday, March 19, 2023
    const formattedTime = now.format('hh:mm A [(GMT]Z[)]'); // 04:29 PM (GMT+2)

    return {
      date: formattedDate,
      time: formattedTime,
    };
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
